"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackPageView = exports.initializeAdsManagerDisabled = exports.initializeAdsManager = void 0;
/* eslint-disable no-underscore-dangle */
var logger_1 = require("../logger");
var logger = logger_1.logger.loggerIn('@sendpayments/js-utils/services/ads-manager');
var adsManagerInitialized;
var adsManagerId;
var scriptPromise;
var injectScript = function (_a) {
    var id = _a.id;
    var groupLogger = logger.groupIn('injectScript');
    window._tfa = window._tfa || [];
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = "//cdn.taboola.com/libtrc/unip/".concat(id, "/tfa.js");
        script.async = 1;
        script.id = 'tb_tfa_script';
        script.addEventListener('load', function () {
            groupLogger.log('injectScript finished loading script');
            resolve();
        });
        script.addEventListener('error', function (e) {
            groupLogger.log('injectScript failed loading script', e);
            reject(e.error);
        });
        document.head.appendChild(script);
    });
};
var awaitScript = function () { return scriptPromise; };
var getSingleton = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!adsManagerInitialized) {
                    logger.error('please initialize first the ads manager service before using it');
                    return [2 /*return*/, undefined];
                }
                return [4 /*yield*/, awaitScript()];
            case 1:
                _a.sent();
                if (window._tfa) {
                    return [2 /*return*/, window._tfa];
                }
                return [2 /*return*/, undefined];
        }
    });
}); };
var initializeAdsManager = function (_a) {
    var credentials = _a.credentials;
    if (adsManagerInitialized) {
        logger.error('you are trying to initialize ads manager and it is already initialized');
        return undefined;
    }
    adsManagerInitialized = true;
    adsManagerId = credentials.id;
    scriptPromise = injectScript({ id: credentials.id });
    return scriptPromise;
};
exports.initializeAdsManager = initializeAdsManager;
var initializeAdsManagerDisabled = function () {
    adsManagerInitialized = true;
    scriptPromise = Promise.resolve();
    logger.log('ads manager is loaded but turned off');
    return scriptPromise;
};
exports.initializeAdsManagerDisabled = initializeAdsManagerDisabled;
var trackPageView = function () { return __awaiter(void 0, void 0, void 0, function () {
    var ref;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getSingleton()];
            case 1:
                ref = _a.sent();
                if (ref) {
                    ref.push({ notify: 'event', name: 'PageView', id: adsManagerId });
                    logger.log("tracking Page View on ".concat(window.location.href));
                }
                return [2 /*return*/, undefined];
        }
    });
}); };
exports.trackPageView = trackPageView;
//# sourceMappingURL=index.js.map